import { Link } from "react-router-dom";

export default function UeberUns() {
  return (
    <div className="flex flex-col min-h-screen">
      {/* Page Header */}
      <section className="pt-24 md:pt-32 pb-10 md:pb-14 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 mb-4 md:mb-6">
              <Link to="/" className="hover:text-primary-600 transition-colors">Startseite</Link>
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line" /></span>
              <span className="text-foreground-700">Über uns</span>
            </nav>
            <h1 className="font-heading font-bold text-foreground-900 text-3xl md:text-4xl lg:text-5xl">
              Über uns
            </h1>
          </div>
        </div>
      </section>

      {/* Company intro */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-4 md:mb-6">
                Wer wir sind
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-4 text-sm md:text-base">
                Die Firma Draude & Wagner GmbH & Co. KG ist ein leistungsstarker Betrieb der Metalloberflächenbeschichtung von Metallteilen der Verbindungstechnik, der Automobilzuliefer- und der Metall- und Elektroindustrie.
              </p>
              <p className="text-foreground-600 leading-relaxed mb-4 text-sm md:text-base">
                Unsere Firmenmitarbeiter mit den Aufgabenschwerpunkten Verzinken, Phosphatieren und Brünieren von Trommelware haben sich zum Ziel gesetzt, den heutigen und zukünftigen Anforderungen an einen nachhaltigen Umweltschutz zum Wohle aller vollständig gerecht zu werden.
              </p>
              <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                Mit jahrelanger Erfahrung und modernster Anlagentechnik garantieren wir höchste Qualität und Zuverlässigkeit für unsere Kunden aus verschiedenen Industriezweigen.
              </p>
            </div>
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/a9beae72ce070f8c28f07fa94c7d3e14/4e108ccff62555f95397b4919d4a00d4.png"
                alt="Draude &amp; Wagner Galvanik GmbH &amp; Co. KG Firmengeb&auml;ude in L&uuml;denscheid"
                className="w-full h-auto rounded-lg object-cover aspect-[4/3]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-10 md:py-16 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-8 md:mb-12 text-center">
              Unsere Werte
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
              {[
                { icon: "ri-shield-check-line", title: "Qualität", desc: "Höchste Ansprüche an Beschichtungsqualität und Prozessstabilität in jeder Charge." },
                { icon: "ri-plant-line", title: "Nachhaltigkeit", desc: "Umweltbewusste Prozesse, Ressourcenschonung und energieeffiziente Anlagentechnik." },
                { icon: "ri-service-line", title: "Partnerschaft", desc: "Langfristige Kundenbeziehungen durch Zuverlässigkeit und transparente Kommunikation." },
                { icon: "ri-lightbulb-line", title: "Innovation", desc: "Kontinuierliche Prozessoptimierung und Investition in moderne Galvaniktechnologie." },
              ].map((item) => (
                <div key={item.title} className="bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70">
                  <div className="w-10 h-10 md:w-12 md:h-10 flex items-center justify-center bg-primary-50 rounded-md mb-3 md:mb-4">
                    <span className="w-5 h-5 md:w-6 md:h-5 flex items-center justify-center text-primary-500 text-lg md:text-xl">
                      <i className={item.icon} />
                    </span>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Standort */}
      <section className="py-10 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="max-w-3xl">
              <h2 className="font-heading font-bold text-foreground-900 text-xl md:text-2xl lg:text-3xl mb-4 md:mb-6">
                Unser Standort
              </h2>
              <p className="text-foreground-600 leading-relaxed mb-4 text-sm md:text-base">
                Unser Betrieb befindet sich im Industriegebiet von L&uuml;denscheid und ist optimal an die Anforderungen der regionalen Metallindustrie angepasst. Die moderne Hallenausstattung erm&ouml;glicht die effiziente Verarbeitung sowohl von Trommelware als auch von Gestellware.
              </p>
              <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
                Die zentrale Lage im Sauerland bietet uns kurze Wege zu unseren Kunden in Nordrhein-Westfalen und dar&uuml;ber hinaus.
              </p>
              <div className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70 inline-block">
                <p className="text-sm text-foreground-700 font-medium mb-1">Draude &amp; Wagner Galvanik GmbH &amp; Co. KG</p>
                <p className="text-sm text-foreground-600">Im Grund 11</p>
                <p className="text-sm text-foreground-600">58513 L&uuml;denscheid</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}